import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { UserConsentPage } from 'features/userConsent'

export const Route = createFileRoute('/_authenticated/consent')({
  component: UserConsentPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('User Consent'),
      },
    ],
  }),
})
